import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import PropTypes from 'prop-types';
// import { VFDropdownBase } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown-base';
import { changeStatusReasonForEditCrqId } from 'AppSrc/core/actions/actions-edit-form';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-actions.css';
// import {
//   getCancelationReasonDisplayOptions,
//   // getDefaultCancelationReason,
// } from 'AppSrc/core/crq/crq-status-reasons';


const CancelationReasonDropdown = ({
  network,
  selectedValue,
  onChange,
}) => {
  // const displayOptions = getCancelationReasonDisplayOptions(network);
  // return (
  //   <VFDropdownBase
  //     displayOptions={displayOptions}
  //     updateValue={onChange}
  //     // fieldTitle="Please enter reason for cancellation"
  //     name="cancelationReason"
  //     value={selectedValue}
  //   />
  // );
};

CancelationReasonDropdown.propTypes = {
  network: PropTypes.string,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
};

const CancelCrqActionsModalDisplay = ({
  closeModal,
  cancelCrqStatus,
  cancelCrq,
  network,
}) => {
  // const defaultReason = getDefaultCancelationReason(network);
  const [selectedReason] = useState('');
  // const readyToSubmit = Boolean(selectedReason);
  const handleCancelCrq = () => {
    cancelCrq(selectedReason);
    cancelCrqStatus();
    closeModal();
  };

  return (
    <ModalPortal>
      <div
        className="v-f-modal-section cancel-crq-modal"
      >
        <div className="v-f-modal-shadow" />
        <div className="v-f-modal-inner">
          <div className="cancel-crq-modal-content">
            <div className="headText">
              <h3>
                Are you sure you want to cancel this CRQ?
              </h3>
            </div>
            {network === 'fixed' ? (
              <div className="lblText">
                This CRQ will be cancelled permanently and cancellation comms will be sent if applicable.
                Please note, the CRQ cannot be reopened once cancelled.
              </div>
            ) : (
              <div className="lblText">
                This CRQ will be cancelled permanently and cannot be reopened. Please notify Change Management so cancellation comms can be sent where applicable.
              </div>
            )}
            {/* <CancelationReasonDropdown
              network={network}
              selectedValue={selectedReason}
              onChange={setSelectedReason}
            /> */}
            <div className="form-modal-options form-modal-options-space-maker" />
            <div className="form-modal-options">
              <div className="side-left">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={closeModal}
                >
                  Back
                </button>
              </div>
              <div className="side-right">
                <button
                  type="button"
                  className="save-button save-button-ready"
                  // className={`save-button save-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                  // disabled={!readyToSubmit}
                  onClick={handleCancelCrq}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

CancelCrqActionsModalDisplay.propTypes = {
  closeModal: PropTypes.func,
  cancelCrqStatus: PropTypes.func,
  cancelCrq: PropTypes.func,
  network: PropTypes.string,
};




const mapDispatchToProps = (dispatch, ownProps) => ({
  cancelCrq(statusReason) {
    const {
      crqId,
    } = ownProps;
    // clear the status_reason when rejecting from peer review
    dispatch(changeStatusReasonForEditCrqId({
      crqId,
      statusReason: statusReason ? statusReason : null,
    }));
  },
});

const CancelCrqActionsModal = connect(
  null,
  mapDispatchToProps,
)(CancelCrqActionsModalDisplay);





export { CancelCrqActionsModal, CancelationReasonDropdown };
